export const keycodes = [
  { sequence: '\r', shortcut: 'return' },
  { sequence: '\x7F', shortcut: 'backspace' },
  { sequence: '\x1B', shortcut: 'escape' },
  { sequence: '\x1B[1~', shortcut: 'home' },
  { sequence: '\x1B\x1B[1~', shortcut: 'home' },
  { sequence: '\x1B[2~', shortcut: 'insert' },
  { sequence: '\x1B[3~', shortcut: 'delete' },
  { sequence: '\x1B[4~', shortcut: 'end' },
  { sequence: '\x1B[A', shortcut: 'up' },
  { sequence: '\x1B[B', shortcut: 'down' },
  { sequence: '\x1B[C', shortcut: 'right' },
  { sequence: '\x1B[D', shortcut: 'left' },

  // <shift>
  { sequence: '\x1B[2;2~', shortcut: 'shift+insert' },
  { sequence: '\x1B[5;2~', shortcut: 'shift+pageup' },
  { sequence: '\x1B[6;2~', shortcut: 'shift+pagedown' },
  { sequence: '\x1B[1;2A', shortcut: 'shift+up' },
  { sequence: '\x1B[1;2B', shortcut: 'shift+down' },
  { sequence: '\x1B[1;2C', shortcut: 'shift+right' },
  { sequence: '\x1B[1;2D', shortcut: 'shift+left' },
  { sequence: '\x1B[Z', shortcut: 'shift+tab' },

  // <meta>
  { sequence: '\x1Bf', shortcut: 'meta+right' },
  { sequence: '\x1Bb', shortcut: 'meta+left' },
  { sequence: '\x1B[1;9A', shortcut: 'meta+up' },
  { sequence: '\x1B[1;9B', shortcut: 'meta+down' },
  { sequence: '\x1B[1;9C', shortcut: 'cmd+meta+right' },
  { sequence: '\x1B[1;9D', shortcut: 'cmd+meta+left' },
  { sequence: '\x1B[2;3~', shortcut: 'meta+insert' },
  { sequence: '\x1B[3;3~', shortcut: 'meta+delete' },
  { sequence: '\x1B[5;3~', shortcut: 'meta+pageup' },
  { sequence: '\x1B[6;3~', shortcut: 'meta+pagedown' },
  { sequence: '\x1B\x7F', shortcut: 'meta+backspace' },

  // <shift+meta>
  { sequence: '\x1B[1;10A', shortcut: 'shift+meta+up' },
  { sequence: '\x1B[1;10B', shortcut: 'shift+meta+down' },
  { sequence: '\x1B[1;10C', shortcut: 'shift+meta+right' },
  { sequence: '\x1B[1;10D', shortcut: 'shift+meta+left' },
  { sequence: '\x1B[2;4~', shortcut: 'shift+meta+insert' },
  { sequence: '\x1B[3;4~', shortcut: 'shift+meta+delete' },
  { sequence: '\x1B[5;4~', shortcut: 'shift+meta+pageup' },
  { sequence: '\x1B[6;4~', shortcut: 'shift+meta+pagedown' },

  // <ctrl>
  { sequence: '\x00', shortcut: 'ctrl+`' },
  { sequence: '\x0c', shortcut: 'ctrl+4' },
  // { sequence: '\x0d', shortcut: 'ctrl+5' },
  { sequence: '\x0e', shortcut: 'ctrl+6' },
  { sequence: '\x0f', shortcut: 'ctrl+7' },
  { sequence: '\x01', shortcut: 'ctrl+a' },
  { sequence: '\x02', shortcut: 'ctrl+b' },
  { sequence: '\x03', shortcut: 'ctrl+c' },
  { sequence: '\x04', shortcut: 'ctrl+d' },
  { sequence: '\x05', shortcut: 'ctrl+e' },
  { sequence: '\x06', shortcut: 'ctrl+f' },
  { sequence: '\x07', shortcut: 'ctrl+g' },
  // { sequence: '\b', shortcut: 'ctrl+h' },
  { sequence: '\t', shortcut: 'ctrl+i' },
  { sequence: '\n', shortcut: 'ctrl+j', command: 'enter' },
  { sequence: '\x0B', shortcut: 'ctrl+k' },
  { sequence: '\f', shortcut: 'ctrl+l' },
  { sequence: '\x0E', shortcut: 'ctrl+n' },
  { sequence: '\x0F', shortcut: 'ctrl+o' },
  { sequence: '\x10', shortcut: 'ctrl+p' },
  { sequence: '\x11', shortcut: 'ctrl+q' },
  { sequence: '\x12', shortcut: 'ctrl+r' },
  { sequence: '\x13', shortcut: 'ctrl+s' },
  { sequence: '\x14', shortcut: 'ctrl+t' },
  { sequence: '\x15', shortcut: 'ctrl+u' },
  { sequence: '\x16', shortcut: 'ctrl+v' },
  { sequence: '\x17', shortcut: 'ctrl+w' },
  { sequence: '\x18', shortcut: 'ctrl+x' },
  { sequence: '\x19', shortcut: 'ctrl+y' },
  { sequence: '\x1A', shortcut: 'ctrl+z' },
  { sequence: '\x1F', shortcut: 'ctrl+-' },
  { sequence: '\x1C', shortcut: 'ctrl+|' },
  { sequence: '\x1D', shortcut: 'ctrl+]' },
  { sequence: '\x1B[1;5A', shortcut: 'ctrl+up', weight: -1 },
  { sequence: '\x1B[1;5B', shortcut: 'ctrl+down', weight: -1 },
  { sequence: '\x1B[1;5C', shortcut: 'ctrl+right', weight: -1 },
  { sequence: '\x1B[1;5D', shortcut: 'ctrl+left', weight: -1 },
  { sequence: '\x1B[2;5~', shortcut: 'ctrl+insert', weight: -1 },
  { sequence: '\x1B[5;5~', shortcut: 'ctrl+pageup', weight: -1 },
  { sequence: '\x1B[6;5~', shortcut: 'ctrl+pagedown', weight: -1 },

  // <ctrl+shift>
  { sequence: '\x1B[1;6B', shortcut: 'ctrl+shift+down' },
  { sequence: '\x1B[1;6D', shortcut: 'ctrl+shift+left' },
  { sequence: '\x1B[1;6C', shortcut: 'ctrl+shift+right' },
  { sequence: '\x1B[1;6A', shortcut: 'ctrl+shift+up' },

  // <ctrl+shift+meta>
  { sequence: '\x1B[1;14B', shortcut: 'ctrl+shift+meta+down' },
  { sequence: '\x1B[1;14D', shortcut: 'ctrl+shift+meta+left' },
  { sequence: '\x1B[1;14C', shortcut: 'ctrl+shift+meta+right' },

  // <fn>
  { sequence: '\x1B[H', shortcut: 'fn+left', name: 'home' },
  { sequence: '\x1B[F', shortcut: 'fn+right', name: 'end' },
  { sequence: '\x1B[5~', shortcut: 'fn+up', name: 'pageup' },
  { sequence: '\x1B[6~', shortcut: 'fn+down', name: 'pagedown' },

  // <fn+ctrl>
  { sequence: '\x1B[1;5F', shortcut: 'fn+ctrl+right' },
  { sequence: '\x1B[1;5H', shortcut: 'fn+ctrl+left' },
  { sequence: '\x1B[3;5~', shortcut: 'fn+ctrl+delete' },

  // <fn+shift>
  { sequence: '\x1B[1;2H', shortcut: 'fn+shift+right', name: 'shift+home' },
  { sequence: '\x1B[1;2F', shortcut: 'fn+shift+left', name: 'shift+end' },
  { sequence: '\x1B[3;2~', shortcut: 'fn+shift+delete' },

  // <fn+meta>
  { sequence: '\x1B[1;9F', shortcut: 'fn+meta+right' },
  { sequence: '\x1B[1;9H', shortcut: 'fn+meta+left' },
  { sequence: '\x1B[5;9~', shortcut: 'fn+meta+up' },
  { sequence: '\x1B[6;9~', shortcut: 'fn+meta+down' },
  { sequence: '\x1B\x1B[5~', shortcut: 'fn+meta+up' },
  { sequence: '\x1B\x1B[6~', shortcut: 'fn+meta+down' },
  { sequence: '\x1Bd', shortcut: 'fn+meta+delete', fn: true },

  // <fn+ctrl+shift>
  { sequence: '\x1B[1;6F', shortcut: 'fn+ctrl+shift+right' },
  { sequence: '\x1B[1;6H', shortcut: 'fn+ctrl+shift+left' },
  { sequence: '\x1B[3;6~', shortcut: 'fn+ctrl+shift+delete' },
  { sequence: '\x1B[5;6~', shortcut: 'fn+ctrl+shift+up' },
  { sequence: '\x1B[6;6~', shortcut: 'fn+ctrl+shift+down' },

  // <fn+ctrl+meta>
  { sequence: '\x1B[1;13F', shortcut: 'fn+ctrl+meta+right' },
  { sequence: '\x1B[1;13H', shortcut: 'fn+ctrl+meta+left' },
  { sequence: '\x1B[3;13~', shortcut: 'fn+ctrl+meta+delete' },

  // <fn+shift+meta>
  { sequence: '\x1B[1;10F', shortcut: 'fn+shift+meta+right' },
  { sequence: '\x1B[1;10H', shortcut: 'fn+shift+meta+left' },
  { sequence: '\x1B[3;10~', shortcut: 'fn+shift+meta+delete' },
  { sequence: '\x1B[5;10~', shortcut: 'fn+shift+meta+up' },
  { sequence: '\x1B[6;10~', shortcut: 'fn+shift+meta+down' },

  // <fn+ctrl+shift+meta>
  { sequence: '\x1B[1;14F', shortcut: 'fn+ctrl+shift+meta+right' },
  { sequence: '\x1B[1;14H', shortcut: 'fn+ctrl+shift+meta+left' },
  { sequence: '\x1B[3;14~', shortcut: 'fn+ctrl+shift+meta+delete' },
  { sequence: '\x1B[5;14~', shortcut: 'fn+ctrl+shift+meta+up' },
  { sequence: '\x1B[6;14~', shortcut: 'fn+ctrl+shift+meta+down' },

  // <f1-f4>
  { sequence: '\x1BOP', shortcut: 'f1' },
  { sequence: '\x1BOQ', shortcut: 'f2' },
  { sequence: '\x1BOR', shortcut: 'f3' },
  { sequence: '\x1BOS', shortcut: 'f4' },

  // <f1-f20>
  { sequence: '\x1B[11~', shortcut: 'f1' },
  { sequence: '\x1B[12~', shortcut: 'f2' },
  { sequence: '\x1B[13~', shortcut: 'f3' },
  { sequence: '\x1B[14~', shortcut: 'f4' },
  { sequence: '\x1B[15~', shortcut: 'f5' },
  { sequence: '\x1B[17~', shortcut: 'f6' },
  { sequence: '\x1B[18~', shortcut: 'f7' },
  { sequence: '\x1B[19~', shortcut: 'f8' },
  { sequence: '\x1B[20~', shortcut: 'f9' },
  { sequence: '\x1B[21~', shortcut: 'f10' },
  { sequence: '\x1B[23~', shortcut: 'f11' },
  { sequence: '\x1B[24~', shortcut: 'f12' },
  { sequence: '\x1B[25~', shortcut: 'f13' },
  { sequence: '\x1B[26~', shortcut: 'f14' },
  { sequence: '\x1B[28~', shortcut: 'f15' },
  { sequence: '\x1B[29~', shortcut: 'f16' },
  { sequence: '\x1B[31~', shortcut: 'f17' },
  { sequence: '\x1B[32~', shortcut: 'f18' },
  { sequence: '\x1B[33~', shortcut: 'f19' },
  { sequence: '\x1B[34~', shortcut: 'f20' },

  // <shift+f1-f12>
  { sequence: '\x1B[1;2P', shortcut: 'shift+f1' },
  { sequence: '\x1B[1;2Q', shortcut: 'shift+f2' },
  { sequence: '\x1B[1;2R', shortcut: 'shift+f3' },
  { sequence: '\x1B[1;2S', shortcut: 'shift+f4' },
  { sequence: '\x1B[15;2~', shortcut: 'shift+f5' },
  { sequence: '\x1B[17;2~', shortcut: 'shift+f6' },
  { sequence: '\x1B[18;2~', shortcut: 'shift+f7' },
  { sequence: '\x1B[19;2~', shortcut: 'shift+f8' },
  { sequence: '\x1B[20;2~', shortcut: 'shift+f9' },
  { sequence: '\x1B[21;2~', shortcut: 'shift+f10' },
  { sequence: '\x1B[23;2~', shortcut: 'shift+f11' },
  { sequence: '\x1B[24;2~', shortcut: 'shift+f12' },

  // <num_key>
  { sequence: '\x1BOp', shortcut: 'num_key_0' },
  { sequence: '\x1BOq', shortcut: 'num_key_1' },
  { sequence: '\x1BOr', shortcut: 'num_key_2' },
  { sequence: '\x1BOs', shortcut: 'num_key_3' },
  { sequence: '\x1BOt', shortcut: 'num_key_4' },
  { sequence: '\x1BOu', shortcut: 'num_key_5' },
  { sequence: '\x1BOv', shortcut: 'num_key_6' },
  { sequence: '\x1BOw', shortcut: 'num_key_7' },
  { sequence: '\x1BOx', shortcut: 'num_key_8' },
  { sequence: '\x1BOy', shortcut: 'num_key_9' },
  { sequence: '\x1BOl', shortcut: 'num_key_comma' },
  { sequence: '\x1BOm', shortcut: 'num_key_minus' },
  { sequence: '\x1BOn', shortcut: 'num_key_period' }
];

export const protocols = {
  kitty: [
    // Enter variants
    { shortcut: 'enter', sequence: '\x1b[13u' },
    { shortcut: 'shift+enter', sequence: '\x1b[13;2u' },
    { shortcut: 'alt+enter', sequence: '\x1b[13;3u' },
    { shortcut: 'shift+alt+enter', sequence: '\x1b[13;4u' },
    { shortcut: 'ctrl+enter', sequence: '\x1b[13;5u' },
    { shortcut: 'shift+ctrl+enter', sequence: '\x1b[13;6u' },
    { shortcut: 'ctrl+alt+enter', sequence: '\x1b[13;7u' },
    { shortcut: 'shift+ctrl+alt+enter', sequence: '\x1b[13;8u' },

    // Tab variants
    { shortcut: 'tab', sequence: '\x1b[9u' },
    { shortcut: 'shift+tab', sequence: '\x1b[9;2u' },
    { shortcut: 'alt+tab', sequence: '\x1b[9;3u' },
    { shortcut: 'ctrl+tab', sequence: '\x1b[9;5u' },
    { shortcut: 'shift+ctrl+tab', sequence: '\x1b[9;6u' },

    // Backspace variants
    { shortcut: 'backspace', sequence: '\x1b[127u' },
    { shortcut: 'shift+backspace', sequence: '\x1b[127;2u' },
    { shortcut: 'alt+backspace', sequence: '\x1b[127;3u' },
    { shortcut: 'ctrl+backspace', sequence: '\x1b[127;5u' },
    { shortcut: 'shift+ctrl+backspace', sequence: '\x1b[127;6u' },

    // Escape variants
    { shortcut: 'escape', sequence: '\x1b[27u' },
    { shortcut: 'shift+escape', sequence: '\x1b[27;2u' },
    { shortcut: 'alt+escape', sequence: '\x1b[27;3u' },
    { shortcut: 'ctrl+escape', sequence: '\x1b[27;5u' },

    // Space variants
    { shortcut: 'space', sequence: '\x1b[32u' },
    { shortcut: 'shift+space', sequence: '\x1b[32;2u' },
    { shortcut: 'alt+space', sequence: '\x1b[32;3u' },
    { shortcut: 'ctrl+space', sequence: '\x1b[32;5u' },
    { shortcut: 'shift+ctrl+space', sequence: '\x1b[32;6u' },

    // Arrow keys
    { shortcut: 'up', sequence: '\x1b[A' },
    { shortcut: 'shift+up', sequence: '\x1b[1;2A' },
    { shortcut: 'alt+up', sequence: '\x1b[1;3A' },
    { shortcut: 'shift+alt+up', sequence: '\x1b[1;4A' },
    { shortcut: 'ctrl+up', sequence: '\x1b[1;5A' },
    { shortcut: 'shift+ctrl+up', sequence: '\x1b[1;6A' },
    { shortcut: 'ctrl+alt+up', sequence: '\x1b[1;7A' },
    { shortcut: 'shift+ctrl+alt+up', sequence: '\x1b[1;8A' },

    { shortcut: 'down', sequence: '\x1b[B' },
    { shortcut: 'shift+down', sequence: '\x1b[1;2B' },
    { shortcut: 'alt+down', sequence: '\x1b[1;3B' },
    { shortcut: 'shift+alt+down', sequence: '\x1b[1;4B' },
    { shortcut: 'ctrl+down', sequence: '\x1b[1;5B' },
    { shortcut: 'shift+ctrl+down', sequence: '\x1b[1;6B' },
    { shortcut: 'ctrl+alt+down', sequence: '\x1b[1;7B' },
    { shortcut: 'shift+ctrl+alt+down', sequence: '\x1b[1;8B' },

    { shortcut: 'right', sequence: '\x1b[C' },
    { shortcut: 'shift+right', sequence: '\x1b[1;2C' },
    { shortcut: 'alt+right', sequence: '\x1b[1;3C' },
    { shortcut: 'shift+alt+right', sequence: '\x1b[1;4C' },
    { shortcut: 'ctrl+right', sequence: '\x1b[1;5C' },
    { shortcut: 'shift+ctrl+right', sequence: '\x1b[1;6C' },
    { shortcut: 'ctrl+alt+right', sequence: '\x1b[1;7C' },
    { shortcut: 'shift+ctrl+alt+right', sequence: '\x1b[1;8C' },

    { shortcut: 'left', sequence: '\x1b[D' },
    { shortcut: 'shift+left', sequence: '\x1b[1;2D' },
    { shortcut: 'alt+left', sequence: '\x1b[1;3D' },
    { shortcut: 'shift+alt+left', sequence: '\x1b[1;4D' },
    { shortcut: 'ctrl+left', sequence: '\x1b[1;5D' },
    { shortcut: 'shift+ctrl+left', sequence: '\x1b[1;6D' },
    { shortcut: 'ctrl+alt+left', sequence: '\x1b[1;7D' },
    { shortcut: 'shift+ctrl+alt+left', sequence: '\x1b[1;8D' },

    // Home/End
    { shortcut: 'home', sequence: '\x1b[H' },
    { shortcut: 'shift+home', sequence: '\x1b[1;2H' },
    { shortcut: 'alt+home', sequence: '\x1b[1;3H' },
    { shortcut: 'ctrl+home', sequence: '\x1b[1;5H' },
    { shortcut: 'shift+ctrl+home', sequence: '\x1b[1;6H' },

    { shortcut: 'end', sequence: '\x1b[F' },
    { shortcut: 'shift+end', sequence: '\x1b[1;2F' },
    { shortcut: 'alt+end', sequence: '\x1b[1;3F' },
    { shortcut: 'ctrl+end', sequence: '\x1b[1;5F' },
    { shortcut: 'shift+ctrl+end', sequence: '\x1b[1;6F' },

    // Insert/Delete
    { shortcut: 'insert', sequence: '\x1b[2~' },
    { shortcut: 'shift+insert', sequence: '\x1b[2;2~' },
    { shortcut: 'alt+insert', sequence: '\x1b[2;3~' },
    { shortcut: 'ctrl+insert', sequence: '\x1b[2;5~' },

    { shortcut: 'delete', sequence: '\x1b[3~' },
    { shortcut: 'shift+delete', sequence: '\x1b[3;2~' },
    { shortcut: 'alt+delete', sequence: '\x1b[3;3~' },
    { shortcut: 'ctrl+delete', sequence: '\x1b[3;5~' },
    { shortcut: 'shift+ctrl+delete', sequence: '\x1b[3;6~' },

    // Page Up/Down
    { shortcut: 'pageup', sequence: '\x1b[5~' },
    { shortcut: 'shift+pageup', sequence: '\x1b[5;2~' },
    { shortcut: 'alt+pageup', sequence: '\x1b[5;3~' },
    { shortcut: 'ctrl+pageup', sequence: '\x1b[5;5~' },

    { shortcut: 'pagedown', sequence: '\x1b[6~' },
    { shortcut: 'shift+pagedown', sequence: '\x1b[6;2~' },
    { shortcut: 'alt+pagedown', sequence: '\x1b[6;3~' },
    { shortcut: 'ctrl+pagedown', sequence: '\x1b[6;5~' },

    // Function keys F1-F12
    { shortcut: 'f1', sequence: '\x1b[11~' },
    { shortcut: 'shift+f1', sequence: '\x1b[11;2~' },
    { shortcut: 'alt+f1', sequence: '\x1b[11;3~' },
    { shortcut: 'ctrl+f1', sequence: '\x1b[11;5~' },

    { shortcut: 'f2', sequence: '\x1b[12~' },
    { shortcut: 'shift+f2', sequence: '\x1b[12;2~' },
    { shortcut: 'alt+f2', sequence: '\x1b[12;3~' },
    { shortcut: 'ctrl+f2', sequence: '\x1b[12;5~' },

    { shortcut: 'f3', sequence: '\x1b[13~' },
    { shortcut: 'shift+f3', sequence: '\x1b[13;2~' },
    { shortcut: 'alt+f3', sequence: '\x1b[13;3~' },
    { shortcut: 'ctrl+f3', sequence: '\x1b[13;5~' },

    { shortcut: 'f4', sequence: '\x1b[14~' },
    { shortcut: 'shift+f4', sequence: '\x1b[14;2~' },
    { shortcut: 'alt+f4', sequence: '\x1b[14;3~' },
    { shortcut: 'ctrl+f4', sequence: '\x1b[14;5~' },

    { shortcut: 'f5', sequence: '\x1b[15~' },
    { shortcut: 'shift+f5', sequence: '\x1b[15;2~' },
    { shortcut: 'alt+f5', sequence: '\x1b[15;3~' },
    { shortcut: 'ctrl+f5', sequence: '\x1b[15;5~' },

    { shortcut: 'f6', sequence: '\x1b[17~' },
    { shortcut: 'shift+f6', sequence: '\x1b[17;2~' },
    { shortcut: 'alt+f6', sequence: '\x1b[17;3~' },
    { shortcut: 'ctrl+f6', sequence: '\x1b[17;5~' },

    { shortcut: 'f7', sequence: '\x1b[18~' },
    { shortcut: 'shift+f7', sequence: '\x1b[18;2~' },
    { shortcut: 'alt+f7', sequence: '\x1b[18;3~' },
    { shortcut: 'ctrl+f7', sequence: '\x1b[18;5~' },

    { shortcut: 'f8', sequence: '\x1b[19~' },
    { shortcut: 'shift+f8', sequence: '\x1b[19;2~' },
    { shortcut: 'alt+f8', sequence: '\x1b[19;3~' },
    { shortcut: 'ctrl+f8', sequence: '\x1b[19;5~' },

    { shortcut: 'f9', sequence: '\x1b[20~' },
    { shortcut: 'shift+f9', sequence: '\x1b[20;2~' },
    { shortcut: 'alt+f9', sequence: '\x1b[20;3~' },
    { shortcut: 'ctrl+f9', sequence: '\x1b[20;5~' },

    { shortcut: 'f10', sequence: '\x1b[21~' },
    { shortcut: 'shift+f10', sequence: '\x1b[21;2~' },
    { shortcut: 'alt+f10', sequence: '\x1b[21;3~' },
    { shortcut: 'ctrl+f10', sequence: '\x1b[21;5~' },

    { shortcut: 'f11', sequence: '\x1b[23~' },
    { shortcut: 'shift+f11', sequence: '\x1b[23;2~' },
    { shortcut: 'alt+f11', sequence: '\x1b[23;3~' },
    { shortcut: 'ctrl+f11', sequence: '\x1b[23;5~' },

    { shortcut: 'f12', sequence: '\x1b[24~' },
    { shortcut: 'shift+f12', sequence: '\x1b[24;2~' },
    { shortcut: 'alt+f12', sequence: '\x1b[24;3~' },
    { shortcut: 'ctrl+f12', sequence: '\x1b[24;5~' },

    // Kitty-specific: letters with modifiers (using CSI u format)
    // Pattern: \x1b[<codepoint>;<modifier>u
    // Modifier bits: 1=shift, 2=alt, 4=ctrl, 8=super
    // Examples for common letter shortcuts:
    { shortcut: 'ctrl+a', sequence: '\x1b[97;5u' },
    { shortcut: 'ctrl+b', sequence: '\x1b[98;5u' },
    { shortcut: 'ctrl+c', sequence: '\x1b[99;5u' },
    { shortcut: 'ctrl+d', sequence: '\x1b[100;5u' },
    { shortcut: 'ctrl+e', sequence: '\x1b[101;5u' },
    { shortcut: 'ctrl+f', sequence: '\x1b[102;5u' },
    { shortcut: 'ctrl+g', sequence: '\x1b[103;5u' },
    { shortcut: 'ctrl+h', sequence: '\x1b[104;5u' },
    { shortcut: 'ctrl+i', sequence: '\x1b[105;5u' },
    { shortcut: 'ctrl+j', sequence: '\x1b[106;5u' },
    { shortcut: 'ctrl+k', sequence: '\x1b[107;5u' },
    { shortcut: 'ctrl+l', sequence: '\x1b[108;5u' },
    { shortcut: 'ctrl+m', sequence: '\x1b[109;5u' },
    { shortcut: 'ctrl+n', sequence: '\x1b[110;5u' },
    { shortcut: 'ctrl+o', sequence: '\x1b[111;5u' },
    { shortcut: 'ctrl+p', sequence: '\x1b[112;5u' },
    { shortcut: 'ctrl+q', sequence: '\x1b[113;5u' },
    { shortcut: 'ctrl+r', sequence: '\x1b[114;5u' },
    { shortcut: 'ctrl+s', sequence: '\x1b[115;5u' },
    { shortcut: 'ctrl+t', sequence: '\x1b[116;5u' },
    { shortcut: 'ctrl+u', sequence: '\x1b[117;5u' },
    { shortcut: 'ctrl+v', sequence: '\x1b[118;5u' },
    { shortcut: 'ctrl+w', sequence: '\x1b[119;5u' },
    { shortcut: 'ctrl+x', sequence: '\x1b[120;5u' },
    { shortcut: 'ctrl+y', sequence: '\x1b[121;5u' },
    { shortcut: 'ctrl+z', sequence: '\x1b[122;5u' },

    { shortcut: 'shift+ctrl+a', sequence: '\x1b[97;6u' },
    { shortcut: 'shift+ctrl+b', sequence: '\x1b[98;6u' },
    { shortcut: 'shift+ctrl+c', sequence: '\x1b[99;6u' },
    { shortcut: 'shift+ctrl+d', sequence: '\x1b[100;6u' },
    { shortcut: 'shift+ctrl+e', sequence: '\x1b[101;6u' },
    { shortcut: 'shift+ctrl+f', sequence: '\x1b[102;6u' },
    { shortcut: 'shift+ctrl+g', sequence: '\x1b[103;6u' },
    { shortcut: 'shift+ctrl+h', sequence: '\x1b[104;6u' },
    { shortcut: 'shift+ctrl+i', sequence: '\x1b[105;6u' },
    { shortcut: 'shift+ctrl+j', sequence: '\x1b[106;6u' },
    { shortcut: 'shift+ctrl+k', sequence: '\x1b[107;6u' },
    { shortcut: 'shift+ctrl+l', sequence: '\x1b[108;6u' },
    { shortcut: 'shift+ctrl+m', sequence: '\x1b[109;6u' },
    { shortcut: 'shift+ctrl+n', sequence: '\x1b[110;6u' },
    { shortcut: 'shift+ctrl+o', sequence: '\x1b[111;6u' },
    { shortcut: 'shift+ctrl+p', sequence: '\x1b[112;6u' },
    { shortcut: 'shift+ctrl+q', sequence: '\x1b[113;6u' },
    { shortcut: 'shift+ctrl+r', sequence: '\x1b[114;6u' },
    { shortcut: 'shift+ctrl+s', sequence: '\x1b[115;6u' },
    { shortcut: 'shift+ctrl+t', sequence: '\x1b[116;6u' },
    { shortcut: 'shift+ctrl+u', sequence: '\x1b[117;6u' },
    { shortcut: 'shift+ctrl+v', sequence: '\x1b[118;6u' },
    { shortcut: 'shift+ctrl+w', sequence: '\x1b[119;6u' },
    { shortcut: 'shift+ctrl+x', sequence: '\x1b[120;6u' },
    { shortcut: 'shift+ctrl+y', sequence: '\x1b[121;6u' },
    { shortcut: 'shift+ctrl+z', sequence: '\x1b[122;6u' },

    { shortcut: 'alt+a', sequence: '\x1b[97;3u' },
    { shortcut: 'alt+b', sequence: '\x1b[98;3u' },
    { shortcut: 'alt+c', sequence: '\x1b[99;3u' },
    { shortcut: 'alt+d', sequence: '\x1b[100;3u' },
    { shortcut: 'alt+e', sequence: '\x1b[101;3u' },
    { shortcut: 'alt+f', sequence: '\x1b[102;3u' },
    { shortcut: 'alt+g', sequence: '\x1b[103;3u' },
    { shortcut: 'alt+h', sequence: '\x1b[104;3u' },
    { shortcut: 'alt+i', sequence: '\x1b[105;3u' },
    { shortcut: 'alt+j', sequence: '\x1b[106;3u' },
    { shortcut: 'alt+k', sequence: '\x1b[107;3u' },
    { shortcut: 'alt+l', sequence: '\x1b[108;3u' },
    { shortcut: 'alt+m', sequence: '\x1b[109;3u' },
    { shortcut: 'alt+n', sequence: '\x1b[110;3u' },
    { shortcut: 'alt+o', sequence: '\x1b[111;3u' },
    { shortcut: 'alt+p', sequence: '\x1b[112;3u' },
    { shortcut: 'alt+q', sequence: '\x1b[113;3u' },
    { shortcut: 'alt+r', sequence: '\x1b[114;3u' },
    { shortcut: 'alt+s', sequence: '\x1b[115;3u' },
    { shortcut: 'alt+t', sequence: '\x1b[116;3u' },
    { shortcut: 'alt+u', sequence: '\x1b[117;3u' },
    { shortcut: 'alt+v', sequence: '\x1b[118;3u' },
    { shortcut: 'alt+w', sequence: '\x1b[119;3u' },
    { shortcut: 'alt+x', sequence: '\x1b[120;3u' },
    { shortcut: 'alt+y', sequence: '\x1b[121;3u' },
    { shortcut: 'alt+z', sequence: '\x1b[122;3u' },

    { shortcut: 'ctrl+alt+a', sequence: '\x1b[97;7u' },
    { shortcut: 'ctrl+alt+b', sequence: '\x1b[98;7u' },
    { shortcut: 'ctrl+alt+c', sequence: '\x1b[99;7u' },
    { shortcut: 'ctrl+alt+d', sequence: '\x1b[100;7u' },
    { shortcut: 'ctrl+alt+e', sequence: '\x1b[101;7u' },
    { shortcut: 'ctrl+alt+f', sequence: '\x1b[102;7u' },
    { shortcut: 'ctrl+alt+g', sequence: '\x1b[103;7u' },
    { shortcut: 'ctrl+alt+h', sequence: '\x1b[104;7u' },
    { shortcut: 'ctrl+alt+i', sequence: '\x1b[105;7u' },
    { shortcut: 'ctrl+alt+j', sequence: '\x1b[106;7u' },
    { shortcut: 'ctrl+alt+k', sequence: '\x1b[107;7u' },
    { shortcut: 'ctrl+alt+l', sequence: '\x1b[108;7u' },
    { shortcut: 'ctrl+alt+m', sequence: '\x1b[109;7u' },
    { shortcut: 'ctrl+alt+n', sequence: '\x1b[110;7u' },
    { shortcut: 'ctrl+alt+o', sequence: '\x1b[111;7u' },
    { shortcut: 'ctrl+alt+p', sequence: '\x1b[112;7u' },
    { shortcut: 'ctrl+alt+q', sequence: '\x1b[113;7u' },
    { shortcut: 'ctrl+alt+r', sequence: '\x1b[114;7u' },
    { shortcut: 'ctrl+alt+s', sequence: '\x1b[115;7u' },
    { shortcut: 'ctrl+alt+t', sequence: '\x1b[116;7u' },
    { shortcut: 'ctrl+alt+u', sequence: '\x1b[117;7u' },
    { shortcut: 'ctrl+alt+v', sequence: '\x1b[118;7u' },
    { shortcut: 'ctrl+alt+w', sequence: '\x1b[119;7u' },
    { shortcut: 'ctrl+alt+x', sequence: '\x1b[120;7u' },
    { shortcut: 'ctrl+alt+y', sequence: '\x1b[121;7u' },
    { shortcut: 'ctrl+alt+z', sequence: '\x1b[122;7u' },

    // Numbers with modifiers
    { shortcut: 'ctrl+0', sequence: '\x1b[48;5u' },
    { shortcut: 'ctrl+1', sequence: '\x1b[49;5u' },
    { shortcut: 'ctrl+2', sequence: '\x1b[50;5u' },
    { shortcut: 'ctrl+3', sequence: '\x1b[51;5u' },
    { shortcut: 'ctrl+4', sequence: '\x1b[52;5u' },
    { shortcut: 'ctrl+5', sequence: '\x1b[53;5u' },
    { shortcut: 'ctrl+6', sequence: '\x1b[54;5u' },
    { shortcut: 'ctrl+7', sequence: '\x1b[55;5u' },
    { shortcut: 'ctrl+8', sequence: '\x1b[56;5u' },
    { shortcut: 'ctrl+9', sequence: '\x1b[57;5u' },

    { shortcut: 'alt+0', sequence: '\x1b[48;3u' },
    { shortcut: 'alt+1', sequence: '\x1b[49;3u' },
    { shortcut: 'alt+2', sequence: '\x1b[50;3u' },
    { shortcut: 'alt+3', sequence: '\x1b[51;3u' },
    { shortcut: 'alt+4', sequence: '\x1b[52;3u' },
    { shortcut: 'alt+5', sequence: '\x1b[53;3u' },
    { shortcut: 'alt+6', sequence: '\x1b[54;3u' },
    { shortcut: 'alt+7', sequence: '\x1b[55;3u' },
    { shortcut: 'alt+8', sequence: '\x1b[56;3u' },
    { shortcut: 'alt+9', sequence: '\x1b[57;3u' },

    // Common punctuation with modifiers
    { shortcut: 'ctrl+/', sequence: '\x1b[47;5u' },
    { shortcut: 'ctrl+\\', sequence: '\x1b[92;5u' },
    { shortcut: 'ctrl+[', sequence: '\x1b[91;5u' },
    { shortcut: 'ctrl+]', sequence: '\x1b[93;5u' },
    { shortcut: 'ctrl+-', sequence: '\x1b[45;5u' },
    { shortcut: 'ctrl+=', sequence: '\x1b[61;5u' },
    { shortcut: 'ctrl+`', sequence: '\x1b[96;5u' },
    { shortcut: 'ctrl+;', sequence: '\x1b[59;5u' },
    { shortcut: "ctrl+'", sequence: '\x1b[39;5u' },
    { shortcut: 'ctrl+,', sequence: '\x1b[44;5u' },
    { shortcut: 'ctrl+.', sequence: '\x1b[46;5u' },

    { shortcut: 'alt+/', sequence: '\x1b[47;3u' },
    { shortcut: 'alt+\\', sequence: '\x1b[92;3u' },
    { shortcut: 'alt+[', sequence: '\x1b[91;3u' },
    { shortcut: 'alt+]', sequence: '\x1b[93;3u' },
    { shortcut: 'alt+-', sequence: '\x1b[45;3u' },
    { shortcut: 'alt+=', sequence: '\x1b[61;3u' },
    { shortcut: 'alt+`', sequence: '\x1b[96;3u' },
    { shortcut: 'alt+;', sequence: '\x1b[59;3u' },
    { shortcut: "alt+'", sequence: '\x1b[39;3u' },
    { shortcut: 'alt+,', sequence: '\x1b[44;3u' },
    { shortcut: 'alt+.', sequence: '\x1b[46;3u' }
  ]
};
